import React, { useMemo } from "react";
import { FlatList, Image, Pressable, StyleSheet, Text, View } from "react-native";
import { useNavigation } from "@react-navigation/native";

import { DivineBackground } from "../../shared/ui/DivineBackground";
import { Header } from "../../shared/ui/Header";

import {
  ConchIcon,
  MalaIcon,
  PrayerHandsIcon,
  SunriseDiyaIcon,
} from "../../shared/ui/menuIcons";

type Row = {
  id: string;
  title: string;
  route: string;
  tint: string;
  bg: string;
  icon: React.ReactNode;
};

export function SadhanaMenuScreen() {
  const navigation = useNavigation<any>();

  const rows = useMemo<Row[]>(
    () => [
      {
        id: "chanting",
        title: "Chanting",
        route: "Chanting",
        tint: "#DC2626",
        bg: "rgba(220,38,38,0.12)",
        // icon: <MalaIcon size={22} color="#DC2626" />,
        icon: (
          <Image
            source={require("../../../assets/chanting.png")}
            style={{ width: 45, height: 40, tintColor: "#fb0a0a" }}
            resizeMode="contain"
          />
        ),
      },
      {
        id: "mangla",
        title: "Mangla Aarti",
        route: "ManglaAarti",
        tint: "#D97706",
        bg: "rgba(217,119,6,0.14)",
        icon: <Text style={{ fontSize: 18, fontWeight: "900", color: "#4F46E5" }}>🪔</Text>,

        // icon: (
        //   <Image
        //     source={require("../../../assets/manglaAarti.jpg")}
        //     style={{ width: 22, height: 22 }}
        //     resizeMode="contain"
        //   />
        // ),
      },
      {
        id: "dandvats",
        title: "Dandvats",
        route: "Dandvats",
        tint: "#EA580C",
        bg: "rgba(234,88,12,0.14)",
        icon: (
          <Image
            source={require("../../../assets/dandavat.png")}
            style={{ width: 30, height: 35, tintColor: "#ee4e14" }}
            resizeMode="contain"
          />
        ),
      },
      {
        id: "reading",
        title: "Reading",
        route: "ReadingScreen",
        tint: "#4F46E5",
        bg: "rgba(79,70,229,0.12)",
        icon: <Text style={{ fontSize: 22, fontWeight: "900", color: "#4F46E5" }}>📖</Text>,
      },
      {
        id: "hearing",
        title: "Hearing",
        route: "Hearing",
        tint: "#7C3AED",
        bg: "rgba(124,58,237,0.12)",
        icon: <Text style={{ fontSize: 22, fontWeight: "900", color: "#7C3AED" }}>👂</Text>,
      },
      {
        id: "deity",
        title: "Deity Worship",
        route: "DeityWorship",
        tint: "#E11D48",
        bg: "rgba(225,29,72,0.12)",
        icon: (
          <Image
            source={require("../../../assets/worship.png")}
            style={{ width: 22, height: 30, tintColor: "#E11D48" }}
            resizeMode="contain"
          />
        ),
      },
      {
        id: "sringar",
        title: "Sringar & GuruPuja",
        route: "Sringar",
        tint: "#DB2777",
        bg: "rgba(219,39,119,0.12)",
        // icon: <Text style={{ fontSize: 18, fontWeight: "900", color: "#DB2777" }}>❀</Text>,
        icon: (
          <Image
            source={require("../../../assets/gurupuja.png")}
            style={{ width: 30, height: 30, tintColor: "#DB2777" }}
            resizeMode="contain"
          />
        ),
      },
      {
        id: "upgrade",
        title: "Up-Gradation",
        route: "UpGradation",
        tint: "#0891B2",
        bg: "rgba(8,145,178,0.12)",
        icon: <Text style={{ fontSize: 18, fontWeight: "900", color: "#0891B2" }}>↑</Text>,
      },
      {
        id: "other",
        title: "Other Seva",
        route: "OtherSeva",
        tint: "#0891B2",
        bg: "rgba(8,145,178,0.12)",
        icon: <Text style={{ fontSize: 18, fontWeight: "900", color: "#0891B2" }}>🌼</Text>,
      },
    ],
    []
  );

  return (
    <DivineBackground overlayColor="#FFF8E7" overlayOpacity={0.9}>
      {/* ✅ header with profile icon */}
      <Header title="Sadhana" showBack showProfile />

      <View style={styles.container}>
        <Text style={styles.pageTitle}>Sadhana</Text>

        <FlatList
          data={rows}
          keyExtractor={(i) => i.id}
          contentContainerStyle={{ paddingBottom: 16 }}
          renderItem={({ item }) => (
            <Pressable
              onPress={() => navigation.navigate(item.route)}
              style={({ pressed }) => [styles.row, pressed && { opacity: 0.92 }]}
            >
              <View style={styles.left}>
                <View style={[styles.bubble, { backgroundColor: item.bg }]}>
                  {item.icon}
                </View>
                <Text style={styles.rowText}>{item.title}</Text>
              </View>

              <Text style={styles.chev}>›</Text>
            </Pressable>
          )}
        />
      </View>
    </DivineBackground>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, paddingHorizontal: 14, paddingTop: 12 },
  pageTitle: { fontSize: 18, fontWeight: "900", color: "#2B1408", marginBottom: 10 },

  row: {
    backgroundColor: "rgba(255,255,255,0.90)",
    borderRadius: 14,
    paddingVertical: 14,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: "rgba(251,146,60,0.18)",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
    shadowColor: "#000",
    shadowOpacity: 0.04,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 6 },
    elevation: 2,
  },
  left: { flexDirection: "row", alignItems: "center", gap: 12 },
  bubble: {
    width: 44,
    height: 44,
    borderRadius: 999,
    alignItems: "center",
    justifyContent: "center",
  },
  rowText: { fontSize: 15.5, fontWeight: "800", color: "#4A2311" },
  chev: { fontSize: 22, fontWeight: "900", color: "rgba(251,146,60,0.65)" },
});